import { showDecimalsIfNeeded } from '../page_components/Dashboard/Allocations/InvestmentInfo'

export const numberToLocaleString = (value: number) => {
  // https://www.notion.so/zap-launchpad/Round-to-two-decimals-27d1442b7ab74cd68c68a540d9d0d83d?pvs=4
  // YO Prodigo - we already did this in a not very well named function - have ammended
  return showDecimalsIfNeeded(value)
}
